<template>
  <!--
    A collection of functions and components related to one device.
  -->
  <div>
    <Portlet
      :title="$t('menu.resorts')"
      icon="map-marked-alt"
      class="resorts"
    >
      <template
        v-if="authenticationHasRole('scope_staff') && (authenticationHasRole('admin') || authenticationHasRole('secondlevel'))"
        slot="buttons"
      >
        <a
          :href="`${ resortManagerUrl }/resorts/new`"
          class="btn btn-sm btn-primary float-right"
          target="_blank"
        >
          <font-awesome-icon
            class="mr-1"
            icon="plus"
          />
          {{ $t('create') }}  {{ $t('menu.resort') }}
        </a>
        <div class="clearfix" />
      </template>
      <a
        v-if="selectedResort != -1"
        :href="getSkilineUrl()"
        class="btn btn-sm btn-primary float-right"
        target="_blank"
      >{{ 'To Skiline.cc' }}</a>
      <ResortSelection
        :id="id" 
        :name="name"
        @resortSelected="selectResort"
        @setResort="resort = $event"
        @setResorts="resorts = $event"
      />
      <ul class="nav nav-tabs mt-4">
        <li
          class="nav-item"
          @click="tabOpened('reportTab'); wasReportTabOpened = true;"
        >
          <a
            ref="reportTab"
            class="nav-link"
            href="#reports"
            data-toggle="tab"
            aria-controls="reports"
            aria-selected="true"
          >{{ 'Reporting' }}</a>
        </li>
        <li
          v-if="authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('resortManagerTab'); wasResortManagerOpened = true;"
        >
          <a
            ref="resortManagerTab"
            class="nav-link active"
            href="#resortManager"
            data-toggle="tab"
            aria-controls="resortManager"
            aria-selected="true"
          >{{ 'Resort Manager' }}</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('detailsTab'); wasDetailsTabOpened = true;"
        >
          <a
            ref="detailsTab"
            class="nav-link"
            href="#details"
            data-toggle="tab"
            aria-controls="details"
            aria-selected="true"
          >{{ $t('details') }}</a>
        </li>
        <li
          v-if="authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('logosTab'); wasLogosTabOpened = true;"
        >
          <a
            ref="logosTab"
            class="nav-link"
            href="#logos"
            data-toggle="tab"
            aria-controls="logos"
            aria-selected="true"
          >Logos</a>
        </li>
        <li
          class="nav-item"
          @click="tabOpened('installationTab'); wasInstallationsTabOpened = true;"
        >
          <a
            ref="installationTab"
            :class="['nav-link', { 'active' : authenticationHasRole('zerolevel') || authenticationHasRole('firstlevel') || authenticationHasRole('firstlevel_connector')}]"
            href="#installationsList"
            data-toggle="tab"
            aria-controls="installationsList"
            aria-selected="true"
          >{{ $t('installations') }}</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('converterTab'); wasConverterTabOpened = true;"
        >
          <a
            ref="converterTab"
            class="nav-link"
            href="#converterConfigs"
            data-toggle="tab"
            aria-controls="converterConfigs"
            aria-selected="true"
          >Connectors</a>
        </li>
        <li
          v-if="authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('spotListTab'); wasSpotTabOpened = true;"
        >
          <a
            ref="spotListTab"
            class="nav-link"
            href="#spotList"
            data-toggle="tab"
            aria-controls="spotList"
            aria-selected="true"
          >{{ 'Spot' }}</a>
        </li>
        <li
          v-if="authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('photopointListTab'); wasPhotopointTabOpened = true;"
        >
          <a
            ref="photopointListTab"
            class="nav-link"
            href="#photopointList"
            data-toggle="tab"
            aria-controls="photopointList"
            aria-selected="true"
          >{{ 'Photopoint' }}</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('locationListTab'); wasLocationTabOpened = true;"
        >
          <a
            ref="locationListTab"
            class="nav-link"
            href="#locationList"
            data-toggle="tab"
            aria-controls="locationList"
            aria-selected="true"
          >Locations</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('pointListTab'); wasPointTabOpened = true;"
        >
          <a
            ref="pointListTab"
            class="nav-link"
            href="#pointList"
            data-toggle="tab"
            aria-controls="pointList"
            aria-selected="true"
          >Points</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('liftTab'); wasLiftOpened = true;"
        >
          <a
            ref="liftTab"
            class="nav-link"
            href="#lift"
            data-toggle="tab"
            aria-controls="lift"
            aria-selected="true"
          >{{ 'Sections' }}</a>
        </li>
        <li
          v-if="showLegacyTabs && authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('sharedTab'); wasSharedOpened = true;"
        >
          <a
            ref="sharedTab"
            class="nav-link"
            href="#shared"
            data-toggle="tab"
            aria-controls="shared"
            aria-selected="true"
          >{{ 'Shared' }}</a>
        </li>
        <li
          v-if="authenticationHasRole('scope_staff') && !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')"
          class="nav-item"
          @click="tabOpened('permissionTab'); wasPermissionOpened = true;"
        >
          <a
            ref="permissionTab"
            class="nav-link"
            href="#permission"
            data-toggle="tab"
            aria-controls="permission"
            aria-selected="true"
          >{{ $t('permissionsBtoB') }}</a>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'converterTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showSidebarAdd"
          >
            <font-awesome-icon
              class="mr-1"
              icon="plus"
            />
            <span>
              Add Connector
            </span>
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'spotListTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <!-- <a
            :href="`https://admin.skiline.cc/php/alturos/content/admin/id/tool/spotCreate.php?resortId=${ selectedResort }`"
            target="_blank"
            class="cursor-pointer btn btn-sm btn-primary float-right"
          ><font-awesome-icon
             class="mr-1"
             icon="plus"
           />
            <span>
              {{ $t('resortSpotAndPhotopoint.addSpot') }}
            </span></a> -->
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showSpotSidebarAdd"
          >
            {{ $t('resortSpotAndPhotopoint.addSpot') }}
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'photopointListTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <!-- <a
            :href="`https://admin.skiline.cc/php/alturos/content/admin/id/tool/photoPointCreate.php?resortId=${ selectedResort }`"
            target="_blank"
            class="cursor-pointer btn btn-sm btn-primary float-right"
          ><font-awesome-icon
             class="mr-1"
             icon="plus"
           />
            <span>
              {{ $t('resortSpotAndPhotopoint.addPhotopoint') }}
            </span></a> -->
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showPhotopointSidebarAdd"
          >
            {{ $t('resortSpotAndPhotopoint.addPhotopoint') }}
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'locationListTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showLocationSidebarAdd"
          >
            Add Location
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'pointListTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <button
            class="btn btn-sm btn-primary float-right"
            @click="showPointSidebarAdd"
          >
            Add Point
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'liftTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="openLiftExportModal"
          >
            <font-awesome-icon
              class="mr-1"
              icon="file-export"
            />
            <span>
              {{ 'Export' }}
            </span>
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'liftTab'"
          class="nav-item"
        >
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showLiftSidebarAdd"
          >
            <font-awesome-icon
              class="mr-1"
              icon="plus"
            />
            <span>
              {{ $t('resortSpotAndPhotopoint.addLift') }}
            </span>
          </button>
        </li>
        <li
          v-if="selectedResort != -1 && openedTab == 'sharedTab'"
          class="nav-item"
          style="margin-left: auto;"
        >
          <button 
            class="btn btn-sm btn-primary float-right" 
            @click="showSharedSidebarAdd"
          >
            <font-awesome-icon
              class="mr-1"
              icon="plus"
            />
            <span>
              {{ $t('sharedResortForms.addSharedResort') }}
            </span>
          </button>
        </li>
      </ul>

      <div class="tab-content">
        <div
          id="reports"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="reports"
        >
          <LoadingPlaceholder v-if="loading" />
          <ReportingComponent
            v-else-if="wasReportTabOpened"
            :resort-id="selectedResort"
            :installations="installations"
          /> 
        </div>
        <div
          id="resortManager"
          :class="['rep-tab-pane', { 'active' : !authenticationHasRole('zerolevel') && !authenticationHasRole('firstlevel') && !authenticationHasRole('firstlevel_connector')}]"
          role="tabpanel"
          aria-labelledby="resortManager"
        >
          <template
            v-if="selectedResort != -1 && wasResortManagerOpened"
          >
            <iframe
              class="iframe"
              :src="`${ resortManagerUrl }/resorts/${ selectedResort }`"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="details"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="details"
        >
          <LoadingPlaceholder v-if="loading" />
          <ResortDetails
            v-else-if="selectedResort != -1 && wasDetailsTabOpened"
            :resort-id="selectedResort"
          />
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="logos"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="logos"
        >
          <LoadingPlaceholder v-if="loading" />
          <ResortLogo
            v-else-if="selectedResort != -1 && wasLogosTabOpened"
            :resort-id="selectedResort"
          />
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="installationsList"
          :class="['rep-tab-pane', { 'active' : authenticationHasRole('zerolevel') || authenticationHasRole('firstlevel') || authenticationHasRole('firstlevel_connector')}]"
          role="tabpanel"
          aria-labelledby="installationsList"
        >
          <LoadingPlaceholder v-if="loading" />
          <InstallationList 
            v-else-if="selectedResort != -1 && wasInstallationsTabOpened"
            :show-all="true"
            :resort-id="selectedResort"
            :is-resort="true"
            :r-installations="installations"
          />
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="converterConfigs"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="converterConfigs"
        >
          <template
            v-if="selectedResort != -1 && wasConverterTabOpened"
          >
            <converterConfigsList
              ref="converterConfigsList"
              :resort-id="selectedResort"
              @reloadAuditLogs="reloadAuditLogs"
            />
            <DatabaseAuditLogList
              ref="databaseAuditLogList"
              :resort-id="selectedResort"
              @reload="reloadConverterConfigs"
            /> 
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="spotList"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="spotList"
        >
          <template
            v-if="selectedResort != -1 && wasSpotTabOpened"
          >
            <SpotList
              ref="spotList"
              :resort-id="selectedResort"
              @reloadAuditLogs="reloadAuditLogs"
            />
            <DatabaseAuditLogList
              ref="databaseAuditLogList"
              :is-spots="true"
              :parent-resort-id="selectedResort"
              @reload="reloadSpots"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="photopointList"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="photopointList"
        >
          <template
            v-if="selectedResort != -1 && wasPhotopointTabOpened"
          >
            <PhotopointList
              ref="photopointList"
              :resort-id="selectedResort"
              @reloadAuditLogs="reloadAuditLogs"
            />
            <DatabaseAuditLogList
              ref="databaseAuditLogList"
              :is-photopoint="true"
              :parent-resort-id="selectedResort"
              @reload="reloadPhotopoints"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="locationList"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="locationList"
        >
          <template
            v-if="selectedResort != -1 && wasLocationTabOpened"
          >
            <LocationList
              ref="locationList"
              :resort-id="selectedResort"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="lift"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="lift"
        >
          <template
            v-if="selectedResort != -1 && wasLiftOpened"
          >
            <ResortLift
              ref="resortLift"
              :resort-id="selectedResort"
              @reloadAuditLogs="reloadAuditLogs"
            />
            <DatabaseAuditLogList
              ref="databaseAuditLogList"
              :is-lift="true"
              :parent-resort-id="selectedResort"
              @reload="reloadLifts"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="pointList"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="pointList"
        >
          <template
            v-if="selectedResort != -1 && wasPointTabOpened"
          >
            <PointOverviewList
              ref="pointOverviewList"
              :resort-id="selectedResort"
              @reloadAuditLogs="reloadAuditLogs"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="shared"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="shared"
        >
          <template
            v-if="selectedResort != -1 && wasSharedOpened"
          >
            <SharedResortsList
              ref="sharedResortsList"
              :resort-id="selectedResort"
              :resorts="resorts"
              @reloadAuditLogs="reloadAuditLogs"
            />
            <DatabaseAuditLogList
              ref="databaseAuditLogList"
              :is-shared-resort="true"
              :parent-resort-id="selectedResort"
              @reload="reloadSharedResorts"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
        <div
          id="permission"
          class="rep-tab-pane"
          role="tabpanel"
          aria-labelledby="permission"
        >
          <template
            v-if="selectedResort != -1 && wasPermissionOpened"
          >
            <iframe
              class="iframe"
              :src="`https://skiline-php.production.anexia.skiline.cc/php/alturos/content/admin/id/tool/resortPermissions.php?resortId=${ selectedResort }`"
            />
          </template>
          <p v-else>
            {{ $t('pleaseSelectResort') }}
          </p>
        </div>
      </div>
    </Portlet>
    <SweetModal
      ref="liftExportModal"
      icon="file-export"
      blocking
      class="overflowHidden"
    >
      <p>{{ $t('resortForm.liftExportTitle') }}</p>
      <LoadingPlaceholder v-if="exportLoading" />
      <form
        v-else
        class="mt-5"
      >
        <div class="row">
          <div class="col-sm">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportId"
                  v-model="checkedLiftFields"
                  value="Id"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportId"
                >Id</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportName"
                  v-model="checkedLiftFields"
                  value="Name"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportName"
                >Name</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportDuration"
                  v-model="checkedLiftFields"
                  value="Duration"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportDuration"
                >{{ $t('duration') }}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportLength"
                  v-model="checkedLiftFields"
                  value="Length"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportLength"
                >{{ $t('length') }}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="longitudeCp"
                  v-model="checkedLiftFields"
                  value="Longitude"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="longitudeCp"
                >{{ $t('longitude') }}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="latitudeCp"
                  v-model="checkedLiftFields"
                  value="Latitude"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="latitudeCp"
                >{{ $t('latitude') }}</label>
              </div>
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportType"
                  v-model="checkedLiftFields"
                  value="Type"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportType"
                >{{ $t('type') }}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportGgnr"
                  v-model="checkedLiftFields"
                  value="ExternalId"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportGgnr"
                >{{ 'ExternalId' }}</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportCPointStartName"
                  v-model="checkedLiftFields"
                  value="Start Location ID"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportCPointStartName"
                >Start Location ID</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="exportCPointEndName"
                  v-model="checkedLiftFields"
                  value="End Location ID"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="exportCPointEndName"
                >End Location ID</label>
              </div>
            </div>
            <div class="form-group">
              <div class="custom-control custom-checkbox">
                <input
                  id="altitudeCp"
                  v-model="checkedLiftFields"
                  value="Altitude"
                  type="checkbox"
                  class="custom-control-input"
                >
                <label
                  class="custom-control-label"
                  for="altitudeCp"
                >{{ $t('altitude') }}</label>
              </div>
            </div>
          </div>
        </div>
      </form>
      <button
        slot="button"
        class="btn btn-secondary float-left mb-3"
        @click="$refs.liftExportModal.close()"
      >
        <span>{{ $t('cancel') }}</span>
      </button>
      <button
        slot="button"
        class="btn btn-primary float-right mb-3"
        @click="exportLift()"
      >
        <span>{{ 'Export' }}</span>
      </button>
      <div class="clearfix" />
    </SweetModal>
  </div>
</template>

<script>
import { authenticationMixin } from '@/mixins/authenticationMixin';
import { SweetModal } from 'sweet-modal-vue';

export default {
  name: 'ResortsView',
  components: {
    ResortSelection: () => import('@/components/Reporting/ResortSelection.vue'),
    InstallationList: () => import('@/components/Installation/InstallationList.vue'),
    ConverterConfigsList: () => import('@/components/ConverterConfigs/ConverterConfigsList.vue'),
    ReportingComponent: () => import('@/components/Reporting/ReportingComponent.vue'),
    DatabaseAuditLogList: () => import('@/components/DatabaseAuditLogs/DatabaseAuditLogsList.vue'),
    ResortDetails: () => import('@/components/Resort/ResortDetails.vue'),
    SpotList: () => import('@/components/Resort/SpotList.vue'),
    PhotopointList: () => import('@/components/Resort/PhotopointList.vue'),
    LocationList: () => import('@/components/Resort/LocationList.vue'),
    PointOverviewList: () => import('@/components/Resort/PointOverviewList.vue'),
    ResortLift: () => import('@/components/Resort/ResortLift.vue'),
    ResortLogo: () => import('@/components/Resort/ResortLogo.vue'),
    SharedResortsList: () => import('@/components/Resort/SharedResortsList.vue'),
    SweetModal
  },
  mixins: [
    authenticationMixin
  ],
  props: {
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: false,
      default: null
    }
  },
  data () {
    return {
      selectedResort: -1,
      installations: null,
      loading: false,
      resort: null,
      openedTab: this.authenticationHasRole('zerolevel') || this.authenticationHasRole('firstlevel') || this.authenticationHasRole('firstlevel_connector') ? 'installationTab' : 'resortManagerTab',
      // Details, Connectors, Locations, Points, Sections and Shared are maintained in the Resort Manager (skiline-bench) now
      showLegacyTabs: false,
      resortManagerUrl: 'https://skiline-bench.lakeside2.prod.alturos.com',
      wasReportTabOpened: false,
      wasResortManagerOpened: false,
      wasDetailsTabOpened: false,
      wasLogosTabOpened: false,
      wasInstallationsTabOpened: false,
      wasConverterTabOpened: false,
      wasSpotTabOpened: false,
      wasPhotopointTabOpened: false,
      wasLocationTabOpened: false,
      wasPointTabOpened: false,
      wasLiftOpened: false,
      wasSharedOpened: false,
      wasPermissionOpened: false,
      checkedLiftFields: [],
      exportLoading: false,
      resorts: []
    }  
  },
  metaInfo () {
      return {
          title: this.$t('menu.resorts')
      }
  },
  methods: {
    openLiftExportModal () {
      this.$refs.liftExportModal.open();
    },
    tabOpened (data) {
      this.openedTab = data;
    },
    reloadConverterConfigs () {
      this.$refs.converterConfigsList.reloadConverterConfigs();
    },
    reloadSpots () {
      this.$refs.spotList.reloadSpots();
    },
    reloadPhotopoints () {
      this.$refs.photopointList.reloadPhotopoints();
    },
    reloadLocations () {
      this.$refs.locationList.reloadLocations();
    },
    reloadPoints () {
      this.$refs.pointOverviewList.reloadPoints();
    },
    reloadLifts () {
      this.$refs.resortLift.reloadLifts();
    },
    reloadSharedResorts () {
      this.$refs.sharedResortsList.reloadSharedResorts();
    },
    reloadAuditLogs () {
      this.$refs.databaseAuditLogList.reloadAuditLogs();
    },
    selectResort (val) {
      this.wasReportTabOpened = this.openedTab == 'reportTab';
      this.wasResortManagerOpened = this.openedTab == 'resortManagerTab';
      this.wasDetailsTabOpened = this.openedTab == 'detailsTab';
      this.wasLogosTabOpened = this.openedTab == 'logosTab';
      this.wasInstallationsTabOpened = this.openedTab == 'installationTab';
      this.wasConverterTabOpened = this.openedTab == 'converterTab';
      this.wasSpotTabOpened = this.openedTab == 'spotListTab';
      this.wasPhotopointTabOpened = this.openedTab == 'photopointListTab';
      this.wasLocationTabOpened = this.openedTab == 'locationListTab';
      this.wasPointTabOpened = this.openedTab == 'pointListTab';
      this.wasLiftOpened = this.openedTab == 'liftTab';
      this.wasSharedOpened = this.openedTab == 'sharedTab';
      this.wasPermissionOpened = this.openedTab == 'permissionTab';
      
      this.selectedResort = val;
     if(val != -1) {
        this.getResortInstallations(val);
      }
    },
    showSidebarAdd () {
      this.$refs.converterConfigsList.showSidebarAdd();
    },
    showSpotSidebarAdd () {
      this.$refs.spotList.showSidebarAdd();
    },
    showPhotopointSidebarAdd () {
      this.$refs.photopointList.showSidebarAdd();
    },
    showLocationSidebarAdd () {
      this.$refs.locationList.showSidebarAdd();
    },
    showPointSidebarAdd () {
      this.$refs.pointOverviewList.showSidebarAdd();
    },
    showLiftSidebarAdd () {
      this.$refs.resortLift.showSidebarAdd();
    },
    showSharedSidebarAdd () {
      this.$refs.sharedResortsList.showSidebarAdd();
    },
    getSkilineUrl () {
      if(this.resort != null && this.resort.linkName) {
        return "https://www.skiline.cc/resort/" + this.resort.linkName;
      } 
      return "";
    },
    //API
    getResortInstallations (id) {
    this.loading = true;
    this.axios.get(`/Resort/GetResortInstallations?resortId=` + id)
      .then((response) => {
        if (response) {
          this.installations = response.data;
        }
      })
      .finally(() => {
        this.loading = false;
      });
    },
    exportLift () {
      this.exportLoading = true;
      this.axios.post(`/Resort/GenerateLiftExport?resortId=` + this.selectedResort, this.checkedLiftFields)
      .then((response) => {
        if (response) {
          const link = document.createElement('a');
          link.href = 'data:application/octet-stream;charset=utf-8;base64,' + response.data;
          link.target = '_blank';
          link.download = 'sections_ ' + this.selectedResort + '.xlsx';
          link.click();
        }
      })
      .finally(() => {
        this.exportLoading = false;
      });
    }
  }
}
</script> 

<style scoped>
.rep-tab-pane:not(.active) {
  display: block;
  height: 0;
  overflow-y: hidden;
}

.iframe {
  width: 100%;
  height: 100vh;
}
</style>
